module.exports = __webpack_public_path__ + "static/media/cups.eab53346.jpg";